import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend } from "../../../backend";
import "./PopularSpaces.css";
import { Link } from "react-router-dom";
import PopularSpaceBtn from "./PopularSpaceBtn";
// import motesrum from "../../../../public/images/popular-spaces/motesrum.jpg";
// import behandlingsrum from "../../../../public/images/popular-spaces/behandlingsrum.webp";
// import kontorshotell from "../../../../public/images/popular-spaces/kontorshotell.jpg";
// import eventlokal from "../../../../public/images/popular-spaces/eventlokal.jpg";
// import kontorslokal from "../../../../public/images/popular-spaces/kontorslokal.jpg";
// import idrott from "../../../../public/images//popular-spaces/idrottshall.jpg";
import { clearFilterSessionStorage } from "../../../utils/filterUtils";

export default function PopularSpaces() {
  const [spaces, setSpaces] = useState([]);

  useEffect(() => {
    const fetchPopular = async () => {
      const { data } = await axios.get(backend(`/api/listings/popular-types`));
      setSpaces(data.data);
    };

    fetchPopular();
  }, []);

  const spaceImages = {
    Möteslokal: "/images/popular-spaces/motesrum.jpg",
    Kontorslokal: "/images/popular-spaces/kontorslokal.jpg",
    "Idrott/danslokal": "/images/popular-spaces/idrottshall.jpg",
    Eventlokal: "/images/popular-spaces/eventlokal.jpg",
    Behandlingsrum: "/images/popular-spaces/behandlingsrum.webp",
    "Kontorshotell/Co-working": "/images/popular-spaces/kontorshotell.jpg",
  };

  const displayLabels = {
    "Kontorshotell/Co-working": "Kontorshotell & Co-working",
    "Idrott/danslokal": "Idrottshall & danslokal",
  };

  const buildSearchUrl = (roomtype) => {
    return `/lediga-lokaler/allakommuner/${roomtype.toLowerCase().replace(/\//g, "&").replace(/&/g, "%26")}`;
  };

  const handleClick = () => {
    clearFilterSessionStorage();
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <section className="popular-spaces">
      <h2>Populära lokaltyper</h2>
      <div className="popular-spaces-grid">
        {spaces.map((space, index) => (
          <Link
            onClick={handleClick}
            to={buildSearchUrl(space.type)}
            key={index}
          >
            <PopularSpaceBtn
              //   key={index}
              image={spaceImages[space.type]}
              label={displayLabels[space.type] || space.type}
              totalSpaces={space.count}
              area={`${space.minArea} - ${space.maxArea}`}
            />
          </Link>
        ))}
      </div>
    </section>
  );
}
